import React, { useMemo } from "react";
import TrackHandler from "./TrackHandler";
import VideoClipItem from "./template/VideoItem.old";
import VideoItem from "./template/VideoItem";
import AudioItem from "./template/AudioItem";
import TextItem from "./template/TextItem";

// import AudioItem from "@/components/item/trackItem/template/AudioItem";
// import TextItem from "@/components/item/trackItem/template/TextItem";
// import ImageItem from "@/components/item/trackItem/template/ImageItem";
// import EffectItem from "@/components/item/trackItem/template/EffectItem";
// import TransitionItem from "@/components/item/trackItem/template/TransitionItem";
// import FilterItem from "@/components/item/trackItem/template/FilterItem";
// import { TrackHeightMap } from "@/stores/clip/data/trackConfig";
import store from "@/stores/clip/trackState";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import "./trackItem.less";
// import StickerItem from "./template/StickerItem";
import CommonItem from "./template/CommonItem";
import { TrackConfig } from "@/stores/clip/data/trackConfig";
import ThumbItem from "./template/ThumbItem";

interface TrackItemProps {
  trackType?: string;
  lineIndex?: number;
  itemIndex?: number;
  trackItem?: {
    width?: string;
    left?: string;
    showWidth?: string;
    showLeft?: string;
    type?: string;
  };
}

const TrackItem: React.FC<TrackItemProps> = ({
  trackType = "",
  lineIndex = 0,
  itemIndex = 0,
  trackItem = {
    width: "0px",
    left: "0px",
    showWidth: "0px",
    showLeft: "0px",
    type: "",
  },
}) => {
  // 判断当前轨道项是否被选中
  const isActive = useMemo(() => {
    return (
      store.selectGroupItem.line === lineIndex &&
      store.selectGroupItem.index === itemIndex
    );
  }, [toJS(store.selectGroupItem), lineIndex, itemIndex]);

  // 组件映射
  const componentMap = useMemo(
    () =>
      new Map<string, React.FC<any>>([
        ["thumb", ThumbItem],
        ["video", store.isClip ? VideoClipItem : VideoItem],
        ["audio", CommonItem],
        ["sticker", CommonItem],
        ["text", CommonItem],
        ["effect", CommonItem],
        ["background", CommonItem],
        ["picInPic", CommonItem],
        ["transition", () => <div>transition</div>],
        ["filter", () => <div>filter</div>],
      ]),
    [store.isClip]
  );

  // 判断当前轨道项是否处于拖动状态
  const isDragState = useMemo(() => {
    return (
      store.moveTrackData.lineIndex === lineIndex &&
      store.moveTrackData.itemIndex === itemIndex
    );
  }, [toJS(store.moveTrackData), lineIndex, itemIndex]);

  // 设置选中轨道项
  const setSelectTrack = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    store.setSelectTrackItem({
      line: lineIndex,
      index: itemIndex,
    });
  };

  // 计算轨道项的样式
  const itemClass = useMemo(() => {
    if (isDragState) {
      return {
        width: trackItem.showWidth,
        left: `${parseInt(trackItem.showLeft || "0", 10) + store.dragData.moveX}px`,
        top: `${store.dragData.moveY}px`,
      };
    }

    return {
      width: trackItem.showWidth,
      left: trackItem.showLeft,
    };
  }, [
    isDragState,
    trackItem.showWidth,
    trackItem.showLeft,
    toJS(store.dragData),
  ]);

  // 获取轨道项的高度
  // const trackHeight = useMemo(
  //   () => TrackHeightMap.get(trackItem.type || ""),
  //   [trackItem.type]
  // );

  // 动态组件
  const DynamicComponent = componentMap.get(trackItem.type || "");

  return (
    <div
      className={`trackItem ${isDragState ? "isDrag" : ""}`}
      style={{
        position: "absolute",
        top: 0,
        height: "100%",
        borderRadius: 10,
        ...itemClass,
      }}
      data-type={trackItem.type}
      data-line={lineIndex}
      data-index={itemIndex}
      onClick={setSelectTrack}
    >
      {/* 操作手柄 */}
      <TrackHandler
        isActive={isActive}
        lineIndex={lineIndex}
        itemIndex={itemIndex}
      />
      {/* 动态渲染组件 */}
      {DynamicComponent && (
        <DynamicComponent
          trackItem={trackItem}
          itemIndex={itemIndex}
          config={TrackConfig.get(trackItem.type)}
        />
      )}
      {/* {lineIndex} {store.moveTrackData.lineIndex} {itemIndex} */}
      {/* {store.moveTrackData.itemIndex} */}
    </div>
  );
};

export default observer(TrackItem);
